import { render, staticRenderFns } from "./PayAdditionalPurchase.vue?vue&type=template&id=00453634&scoped=true"
import script from "./PayAdditionalPurchase.vue?vue&type=script&lang=ts"
export * from "./PayAdditionalPurchase.vue?vue&type=script&lang=ts"
import style0 from "./PayAdditionalPurchase.vue?vue&type=style&index=0&id=00453634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00453634",
  null
  
)

export default component.exports